


































































































































































import {Component, Vue} from 'vue-property-decorator';
import {AxiosStatic} from "axios";
import IUser from '@/interfaces/IUser';

@Component
export default class UserMenu extends Vue {
	public $http!: AxiosStatic;

	$refs!: {
		passwordmodal: any
		emailmodal: any
		usermodal: any
	};

	public show: boolean = false;
	public currentpassword: string = '';
	public newpassword: string = '';
	public newpasswordrepeat: string = '';
	public setpasswordError: boolean = false;
	public setpasswordCurrentPasswordWrong: boolean = false;
	public setpasswordSuccess: boolean = false;
	public newemail: string = '';
	public setemailErrorText: string = '';
	public setemailError: boolean = false;
	public setemailCurrentPasswordWrong: boolean = false;
	public setemailSuccess: boolean = false;
	public newUserName: string = "";
	public setUserNameErrorText: string = '';
	public setUserNameError: boolean = false;
	public setUserNameSuccess: boolean = false;
	public loading: boolean = false;

	get user(): IUser {
		return this.$store.state.user;
	}

	mounted() {
		this.$root.$on('bv::modal::hidden', (bvEvent: any, modalId: string) => {
			if (modalId === 'passwordmodal') {
				this.resetPasswordModalState();
			}
			if (modalId === 'emailmodal') {
				this.resetEmailModalState();
			}
			if (modalId === 'usermodal') {
				this.resetUserNameModalState();
			}
		})
		this.$root.$on('bv::show::modal', (bvEvent: any, modalId: string) => {
			if(this.user) {
				this.newUserName = this.user.name;
				this.newemail = this.user.email;
			}
		})
	}

	public toggle() {
		this.show = !this.show;
	}

	public logout() {
		this.show = false;
		let url = '/public/logout';
		this.$http.get(url).then((response) => {
			this.$store.commit('RESET_STATE', null);
		}).catch((error) => {
			console.log(error);
		})
	}

	public hidePasswordModal() {
		this.$refs.passwordmodal.hide()
	}

	public hideUserModal() {
		this.$refs.usermodal.hide()
	}

	public hideEmailModal() {
		this.$refs.emailmodal.hide()
	}

	public setPassword() {
		let url = '/private/currentuser';
		this.setpasswordSuccess = false;
		this.setpasswordError = false;
		this.setpasswordCurrentPasswordWrong = false;
		if (this.newpassword == this.newpasswordrepeat) {
			this.loading = true;
			this.$http.put(url, {'currentpassword': this.currentpassword, 'password': this.newpassword}).then((response) => {
				this.setpasswordSuccess = true;
				this.loading = false;
			}).catch((error) => {
				if (error.response.status == 403) {
					this.setpasswordCurrentPasswordWrong = true;
				} else {
					this.setpasswordError = true;
				}
				this.loading = false;
			})
		}
	}

	public resetPasswordModalState() {
		this.loading = false;
		this.currentpassword = '';
		this.newpassword = '';
		this.newpasswordrepeat = '';
		this.setpasswordError = false;
		this.setpasswordCurrentPasswordWrong = false;
		this.setpasswordSuccess = false;
	}

	public setEmail() {
		let url = '/private/currentuser';
		this.setemailSuccess = false;
		this.setemailError = false;
		this.setemailCurrentPasswordWrong = false;
		this.loading = true;
		this.$http.put(url, {'currentpassword': this.currentpassword, 'email': this.newemail}).then((response) => {
			this.setemailSuccess = true;
			this.loading = false;
			this.$store.dispatch('loadCurrentuser', {root: true});
		}).catch((error) => {
			if (error.response.status == 403) {
				this.setemailCurrentPasswordWrong = true;
			} else {
				if (error.response.data.hasOwnProperty('error') && error.response.data.error == 'invalid email') {
					this.setemailErrorText = 'Die angegebene E-Mail ist keine gültige E-Mail Adresse.'
				} else if (error.response.data.hasOwnProperty('error') && error.response.data.error == 'already used email') {
					this.setemailErrorText = 'Diese E-Mail ist bereits benutzt. Gib eine andere E-Mail Adresse ein.'
				} else {
					this.setemailErrorText = '';
				}
				this.setemailError = true;
			}
			this.loading = false;
		})
	}

	public setUserName() {
		let url = '/private/currentuser';
		this.setUserNameSuccess = false;
		this.setUserNameError = false;
		this.loading = true;
		this.$http.put(url, {'name': this.newUserName}).then((response) => {
			this.setUserNameSuccess = true;
			this.loading = false;
			this.$store.dispatch('loadCurrentuser', {root: true});
		}).catch((error) => {
			if (error.response.data.hasOwnProperty('error')) {
				this.setUserNameErrorText = error.response.data.error
			} else {
				this.setUserNameErrorText = '';
			}
			this.setUserNameError = true;
			this.loading = false;
		})
	}

	public resetEmailModalState() {
		this.loading = false;
		this.currentpassword = '';
		this.newemail = '';
		this.setemailErrorText = '';
		this.setemailError = false;
		this.setemailCurrentPasswordWrong = false;
		this.setemailSuccess = false;
	}

	public resetUserNameModalState() {
		this.loading = false;
		this.newUserName = this.user.name;
		this.setUserNameErrorText = '';
		this.setUserNameError = false;
		this.setUserNameSuccess = false;
	}
}
